/*

Project Name: Onyx Praxis WP Theme
Project URI: https://praxis.onixes.com
Author: Obada Qawwas
Author URI: https://www.onyxdev.net
Version: 1.0

*/

var ONYX_VERSION = '1.0';

// Global Onyx object
var Onyx = Onyx || {};

// Gobal variables
var mobileTest;

Onyx = {
    version: ONYX_VERSION,

    // Define defaults values
    defaults: {
        debug: false,
        stopIsVisible: false,
        stopHeaderMasking: false,
    },

    _prefersReducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)'),

    /**
     * Fire all functions
     **/
    init: function ($) {
        var self = this,
            obj;

        for (obj in self) {
            if (self.hasOwnProperty(obj)) {
                var _method = self[obj];

                if (_method.selector !== undefined && _method.init !== undefined) {
                    if ($(_method.selector).length > 0) {
                        _method.init();
                    }
                }
            }
        }
    },

    /**
     * Onyx console note
     **/
    consoleNote: {
        selector: 'html',
        init: function () {
            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
                var t = [
                    '\n %c Made with ♥ by Onyx %c %c %c http://onyxdev.net/ \n\n',
                    'color: #fff; background: #b0976d; padding:5px 0;',
                    'background: #494949; padding:5px 0;',
                    'background: #494949; padding:5px 0;',
                    'color: #fff; background: #1c1c1c; padding:5px 0;',
                ];

                window.console.log.apply(console, t);
            } else window.console && window.console.log('Made with ♥ by Onyx - http://onyxdev.net/');
        },
    },

    /**
     * Function to print results in the console if the above debug is true
     **/
    log: function () {
        if (Onyx.defaults.debug === true) {
            console.log.apply(console, arguments);
        }
    },

    /**
     * Detect touch devices
     **/
    isTouchSupported: function () {
        var agent = navigator.userAgent.toLowerCase(),
            isChromeDesktop =
                agent.indexOf('chrome') > -1 &&
                (agent.indexOf('windows') > -1 || agent.indexOf('macintosh') > -1 || agent.indexOf('linux') > -1) &&
                agent.indexOf('mobile') < 0 &&
                agent.indexOf('android') < 0;
        return 'ontouchstart' in window && !isChromeDesktop;
    },

    /**
     * Detect user's platform
     **/
    platformDetect: {
        selector: 'html',
        init: function () {
            var base = this,
                container = $(base.selector);

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
                mobileTest = true;
                container.addClass('mobile');
            } else {
                mobileTest = false;
                container.addClass('no-mobile');
            }

            var mozillaTest;

            if (/mozilla/.test(navigator.userAgent)) {
                mozillaTest = true;
            } else {
                mozillaTest = false;
            }

            var safariTest;

            if (/safari/.test(navigator.userAgent)) {
                safariTest = true;
            } else {
                safariTest = false;
            }

            // Detect touch devices
            if (!('ontouchstart' in document.documentElement)) {
                document.documentElement.className += ' no-touch';
            }
        },
    },

    /**
     * Helpers functions
     **/
    helpers: {
        selector: 'body',
        init: function () {
            // Print current year in footer
            var fullDate = new Date(),
                fullYear = fullDate.getFullYear();

            // Even if there was a year in the container it will overwrite it
            $('.current-year').html(fullYear);

            /**
             *	Extend jQuery to add easing function
             **/
            jQuery.extend(jQuery.easing, {
                easeInOutQuart: function (x, t, b, c, d) {
                    if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;

                    return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
                },
                easeInOutElastic: function (x, t, b, c, d) {
                    var s = 1.70158;
                    var p = 0;
                    var a = c;

                    if (t == 0) return b;
                    if ((t /= d / 2) == 2) return b + c;
                    if (!p) p = d * (0.3 * 1.5);
                    if (a < Math.abs(c)) {
                        a = c;

                        var s = p / 4;
                    } else var s = (p / (2 * Math.PI)) * Math.asin(c / a);
                    if (t < 1)
                        return (
                            -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin(((t * d - s) * (2 * Math.PI)) / p)) + b
                        );

                    return a * Math.pow(2, -10 * (t -= 1)) * Math.sin(((t * d - s) * (2 * Math.PI)) / p) * 0.5 + c + b;
                },
            });

            // Scroll down button
            $('.scroll-down, #go-to-top, .scroll-to').on('click keydown', function (e) {
                if (e.type === 'keydown' && e.which !== 13 && e.which !== 32) return;

                e.preventDefault();

                // Stop the header from masking
                //Onyx.defaults.stopHeaderMasking = true;

                var section = 0,
                    target = $(this).attr('data-target');

                if (typeof target == undefined || target == undefined || target == '') {
                    target = $('.main-banner').next();
                }

                section = $(target).offset().top; // parseInt( $('.header').outerHeight(), 10)

                $('html, body').animate(
                    {
                        scrollTop: section,
                    },
                    100,
                    'easeInOutQuart',
                    function () {
                        setTimeout(function () {
                            //Onyx.defaults.stopHeaderMasking = false; // Re-init header masking
                        }, 1000);
                    },
                );
            });
        },
    },

    /**
     * Making our header sticky
     **/
    headerFunctions: {
        selector: '.header',
        init: function () {
            var base = this,
                container = $(base.selector),
                lastScrollTop = 0,
                delta = 5,
                logoIconHeight = parseInt($('.main-sidebar__logo').outerHeight(), 10);

            // Don't show sticky if it's a 404 page
            if (!$('body').hasClass('error404')) {
                // Hide/Show header on scroll
                if (!$('body').hasClass('static--header')) {
                    var lastScrollTop = 0,
                        delta = 5;

                    /**
                     *	Start fixed header
                     **/
                    var fixedHeader = $('.header').clone().addClass('header--fixed').addClass('hidden');

                    // Append it to the main wrapper
                    $('main.wrapper').prepend(fixedHeader);

                    $(window)
                        .on('resize scroll', function () {
                            var st = $(this).scrollTop();

                            // Start the action
                            if (!Onyx.defaults.stopHeaderMasking) {
                                Onyx.headerFunctions.scrollDownEffect(
                                    st,
                                    fixedHeader,
                                    lastScrollTop,
                                    delta,
                                    logoIconHeight,
                                );
                            }

                            // Reset
                            lastScrollTop = st;
                        })
                        .trigger('resize');
                }

                /**
                 *	Prepare mobile menu
                 **/
                Onyx.headerFunctions.initMobileMenu(container);
            }
        },
        scrollDownEffect: function (st, container, lastScrollTop, delta, logoIconHeight) {
            if (Math.abs(lastScrollTop - st) <= delta) return;

            if (
                st > lastScrollTop &&
                lastScrollTop > 0 &&
                st > parseInt($(window).outerHeight() / 2, 10) &&
                !$('body').hasClass('menu-is-open')
            ) {
                // Scroll down
                container.addClass('masked');

                // Change logo icon's size
                $('.main-sidebar__logo').addClass('main-sidebar__logo--smaller');

                // Make an event when masking header
                $(document).trigger({
                    type: 'maskingHeader',
                    message: 'Our header has been masked!',
                    time: new Date(),
                });

                Onyx.log('Hide header');
            } else {
                // Scroll up
                container.removeClass('masked');

                // Start header's transforming
                if (st > parseInt($(window).outerHeight() / 2, 10)) {
                    container.removeClass('hidden');

                    // Change logo icon's size
                    $('.main-sidebar__logo').addClass('main-sidebar__logo--smaller');
                } else {
                    container.addClass('hidden');

                    // Change logo icon's size
                    $('.main-sidebar__logo').removeClass('main-sidebar__logo--smaller');
                }

                // Make an event when masking header
                $(document).trigger({
                    type: 'unMaskingHeader',
                    message: 'Our header has been unmasked!',
                    time: new Date(),
                });

                Onyx.log('Show header');
            }
        },
        initMobileMenu: function (container) {
            Onyx.defaults.menuOpened = false;

            var menuBtn = $('.mobile-menu-trigger');

            $(window).on('click', function (e) {
                if (0 < !$(e.target).parents('header').length) {
                    Onyx.headerFunctions.closeMobileMenu();
                }
            });

            menuBtn.attr('aria-expanded', 'false');
            menuBtn.on('click keydown', function (e) {
                if (e.type === 'keydown' && e.which !== 13 && e.which !== 32) return;

                e.preventDefault();

                if (Onyx.defaults.menuOpened) {
                    Onyx.headerFunctions.closeMobileMenu(container, $(this));
                } else {
                    Onyx.headerFunctions.openMobileMenu(container, $(this));
                }
            });
        },
        openMobileMenu: function (container, menuBtn) {
            Onyx.defaults.menuOpened = true;
            $('body').addClass('menu-open');
            menuBtn.addClass('open').attr('aria-expanded', 'true');
            // Prevent scroll on body
            $('html').addClass('overflow-hidden');

            // Set menu's height
            if ($(window).outerWidth() <= 992) {
                if (menuBtn.parents('.header--fixed').length === 0) {
                    $('.header__nav').css(
                        'height',
                        parseInt(
                            $(window).outerHeight() -
                                ($('.header').not('.header--fixed').outerHeight() + $('.main-sidebar').outerHeight()),
                            10,
                        ) + 'px',
                    );
                } else {
                    $('.header__nav').css(
                        'height',
                        parseInt($(window).outerHeight() - $('.header.header--fixed').outerHeight(), 10) + 'px',
                    );
                }
            }
        },
        closeMobileMenu: function (container, menuBtn) {
            if (!Onyx.defaults.menuOpened) {
                return false;
            }
            Onyx.defaults.menuOpened = false;
            $('body').removeClass('menu-open');
            menuBtn.removeClass('open').attr('aria-expanded', 'false');
            // Prevent scroll on body
            $('html').removeClass('overflow-hidden');

            // Set menu's height
            if ($(window).outerWidth() <= 992) {
                setTimeout(function () {
                    $('.header__nav').css('height', 0);
                }, 300);
            }
        },
    },

    /**
     * Onyx slider
     **/
    onyxSlider: {
        selector: '.onyx-slider',
        init: function () {
            var base = this,
                containers = document.querySelectorAll(base.selector);
            var loc = typeof onyx_js_localized !== 'undefined' ? onyx_js_localized : {};

            Onyx.log('A slider is gonna run!');

            containers.forEach(function (el) {
                // Read data attributes
                var sliderLoop = el.getAttribute('data-slider-loop') === 'true';
                var autoPlay = el.getAttribute('data-slider-autoplay') === 'true';
                var autoplaySpeed = parseInt(el.getAttribute('data-slider-autoplay-speed'), 10) || 2000;
                var useFade = el.getAttribute('data-slider-fade') === 'true';
                var variableWidth = el.getAttribute('data-slider-variable-width') === 'true';
                var navContainer = el.getAttribute('data-slider-nav-container');
                var showArrows = !!navContainer;
                var perPage = parseInt(el.getAttribute('data-slides-per-view'), 10) || 1;
                var perMove = parseInt(el.getAttribute('data-slides-scroll'), 10) || 1;

                // Determine type
                var type = useFade ? 'fade' : sliderLoop ? 'loop' : 'slide';

                // Respect prefers-reduced-motion
                var reducedMotion = Onyx._prefersReducedMotion && Onyx._prefersReducedMotion.matches;

                // Build Splide options
                var options = {
                    type: type,
                    perPage: perPage,
                    perMove: perMove,
                    speed: reducedMotion ? 0 : 500,
                    autoplay: reducedMotion ? false : autoPlay,
                    interval: autoplaySpeed,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    arrows: showArrows,
                    pagination: true,
                    autoWidth: variableWidth,
                    direction: document.body.classList.contains('rtl') ? 'rtl' : 'ltr',
                    rewind: !sliderLoop,
                    i18n: {
                        prev: 'Previous slide',
                        next: 'Next slide',
                        slideX: loc.go_to_slide || 'Go to slide %s',
                        pageX: loc.go_to_slide || 'Go to page %s',
                        play: loc.play_carousel || 'Start autoplay',
                        pause: loc.pause_carousel || 'Pause autoplay',
                        slideLabel: loc.slide_x_of_y || '%s of %s',
                    },
                    breakpoints: {
                        1024: {
                            perPage: perPage,
                            perMove: perPage,
                        },
                        800: {
                            perPage: Math.round(perPage * 0.75) || 1,
                            perMove: Math.round(perPage * 0.75) || 1,
                        },
                        480: {
                            perPage: 1,
                            perMove: 1,
                        },
                    },
                };

                var splide = new Splide(el, options);

                // --- Events ---

                // Add 'loaded' class to grandparent on mount
                splide.on('mounted', function () {
                    var grandparent = el.parentElement ? el.parentElement.parentElement : null;
                    if (grandparent) grandparent.classList.add('loaded');

                    // Move arrows to external nav container
                    if (navContainer) {
                        var navTarget = document.querySelector(navContainer);
                        if (navTarget) {
                            var arrows = el.querySelectorAll('.splide__arrow');
                            arrows.forEach(function (arrow) {
                                arrow.classList.add('onyx-slider__nav');
                                if (arrow.classList.contains('splide__arrow--prev')) {
                                    arrow.classList.add('onyx-slider__nav--prev');
                                } else {
                                    arrow.classList.add('onyx-slider__nav--next');
                                }
                                navTarget.appendChild(arrow);
                            });
                        }
                    }

                    // Move pagination to .slider-dots-container
                    var dotsContainer = el.parentElement
                        ? el.parentElement.querySelector('.slider-dots-container')
                        : null;
                    if (dotsContainer) {
                        var pagination = el.querySelector('.splide__pagination');
                        if (pagination) {
                            dotsContainer.appendChild(pagination);
                        }
                    }
                });

                // Related slider sync
                if (el.getAttribute('data-related-slider')) {
                    var relatedSlider = document.querySelector(el.getAttribute('data-related-slider'));
                    if (relatedSlider) {
                        splide.on('move', function (newIndex, prevIndex) {
                            var prevSlide = relatedSlider.querySelector('.slide-' + prevIndex);
                            var nextSlide = relatedSlider.querySelector('.slide-' + newIndex);
                            if (prevSlide) prevSlide.classList.remove('active');
                            if (nextSlide) nextSlide.classList.add('active');
                        });
                    }
                }

                // Click to go to slide
                if (el.getAttribute('data-slide-on-click') === 'true') {
                    splide.on('click', function (slide) {
                        splide.go(slide.index);
                    });
                }

                // Mount the slider
                splide.mount();

                // Pause/play button (after mount so autoplay component is ready)
                if (autoPlay && !reducedMotion) {
                    var pauseText = loc.pause_carousel || 'Pause carousel';
                    var playText = loc.play_carousel || 'Play carousel';
                    var pauseWord = loc.pause || 'Pause';
                    var playWord = loc.play || 'Play';

                    var pauseBtn = document.createElement('button');
                    pauseBtn.type = 'button';
                    pauseBtn.className = 'onyx-slider__pause';
                    pauseBtn.setAttribute('aria-label', pauseText);
                    pauseBtn.innerHTML = '<span class="sr-only">' + pauseWord + '</span>';

                    var pauseSrOnly = pauseBtn.querySelector('.sr-only');
                    var manuallyPaused = false;

                    pauseBtn.addEventListener('click', function () {
                        var Autoplay = splide.Components.Autoplay;
                        if (manuallyPaused) {
                            Autoplay.play();
                            manuallyPaused = false;
                            pauseBtn.setAttribute('aria-label', pauseText);
                            pauseBtn.classList.remove('onyx-slider__pause--paused');
                            pauseSrOnly.textContent = pauseWord;
                        } else {
                            Autoplay.pause();
                            manuallyPaused = true;
                            pauseBtn.setAttribute('aria-label', playText);
                            pauseBtn.classList.add('onyx-slider__pause--paused');
                            pauseSrOnly.textContent = playWord;
                        }
                    });

                    el.appendChild(pauseBtn);
                }
            });
        },
    },

    /**
     * Forms validation with Ajax (vanilla JS — Constraint Validation API)
     *
     * Validates all `.onyx-validation` forms using the native Constraint Validation API.
     * Replaces the former bootstrapValidator.min.js (v0.5.2) jQuery plugin.
     *
     * HTML contract:
     *   - Each field must be inside a `.form-group` container
     *   - Custom error messages via data attributes:
     *       data-msg-required  — shown when field is empty (valueMissing)
     *       data-msg-type      — shown for type mismatch (e.g. invalid email)
     *       data-msg-length    — shown for minlength/maxlength violations
     *   - Native HTML5 attrs (`required`, `minlength`, `maxlength`, `type`) drive validation
     *
     * CSS classes applied (same as the old plugin — no CSS changes needed):
     *   .has-error   — on .form-group when field is invalid
     *   .has-success — on .form-group when field is valid
     *   .help-block  — error message <small> appended inside .form-group
     *
     * Submit behaviour:
     *   - If grecaptcha is present, prevents default and executes reCAPTCHA
     *   - Otherwise, if form lacks `.no-ajax`, submits via globalFormsAjax()
     *   - Forms with `.no-ajax` (e.g. search) submit natively
     *
     * Accessibility:
     *   - aria-invalid="true" set on invalid fields
     *   - aria-describedby links field to its .help-block error message
     *   - First invalid field receives focus on failed submission
     **/
    formsValidationsAjax: {
        selector: '.onyx-validation',
        init: function () {
            var self = this;
            var forms = document.querySelectorAll(self.selector);

            forms.forEach(function (form) {
                var submitted = false;

                // Disable native browser tooltips — we show our own messages
                form.setAttribute('novalidate', '');

                form.addEventListener('submit', function (e) {
                    submitted = true;

                    // Validate all fields
                    var fields = form.querySelectorAll(
                        'input:not([type="hidden"]):not([type="checkbox"]), textarea, select',
                    );

                    var isValid = true;

                    fields.forEach(function (field) {
                        if (!self.validateField(field)) isValid = false;
                    });

                    if (!isValid) {
                        e.preventDefault();

                        var firstError = form.querySelector('.has-error input, .has-error textarea, .has-error select');

                        if (firstError) firstError.focus();

                        return;
                    }

                    // Valid — reCAPTCHA or AJAX submit
                    if (typeof grecaptcha !== 'undefined') {
                        e.preventDefault();
                        if (grecaptcha.getResponse() === '') grecaptcha.execute();
                    } else {
                        Onyx.log('Submitting!');

                        if (!form.classList.contains('no-ajax')) {
                            e.preventDefault();
                            globalFormsAjax('', $(form));
                        }
                    }
                });

                // Re-validate on input after first submission
                form.addEventListener('input', function (e) {
                    if (
                        submitted &&
                        e.target.matches('input:not([type="hidden"]):not([type="checkbox"]), textarea, select')
                    ) {
                        self.validateField(e.target);
                    }
                });
            });
        },
        /**
         * Validate a single field against its native constraints.
         * Toggles .has-error/.has-success on the parent .form-group and
         * manages .help-block error message + ARIA attributes.
         *
         * @param {HTMLElement} field - The input/textarea/select to validate
         * @return {boolean} true if valid, false if invalid
         */
        validateField: function (field) {
            var group = field.closest('.form-group');

            if (!group) return true;

            // Reset previous state
            group.classList.remove('has-error', 'has-success');
            var oldHelp = group.querySelector('.help-block');
            if (oldHelp) oldHelp.remove();
            field.removeAttribute('aria-invalid');
            field.removeAttribute('aria-describedby');

            // Run native Constraint Validation API check
            if (!field.checkValidity()) {
                var msg = Onyx.formsValidationsAjax.getErrorMessage(field);

                group.classList.add('has-error');
                field.setAttribute('aria-invalid', 'true');

                var helpBlock = document.createElement('small');

                helpBlock.className = 'help-block';
                helpBlock.textContent = msg;

                var errorId = (field.id || field.name) + '-error';
                helpBlock.id = errorId;
                field.setAttribute('aria-describedby', errorId);

                group.appendChild(helpBlock);
                return false;
            }

            group.classList.add('has-success');
            return true;
        },
        /**
         * Return the appropriate custom error message for a field based on
         * which constraint failed. Falls back to generic messages.
         *
         * Data attributes checked (in priority order):
         *   data-msg-required — valueMissing
         *   data-msg-type     — typeMismatch (e.g. email format)
         *   data-msg-length   — tooShort / tooLong
         *
         * @param {HTMLElement} field - The invalid field
         * @return {string} Human-readable error message
         */
        getErrorMessage: function (field) {
            var validity = field.validity;

            if (validity.valueMissing) {
                return field.getAttribute('data-msg-required') || 'This field is required.';
            }

            if (validity.typeMismatch || validity.patternMismatch) {
                return field.getAttribute('data-msg-type') || 'Please enter a valid value.';
            }

            if (validity.tooShort || validity.tooLong) {
                return field.getAttribute('data-msg-length') || 'Please enter a valid value.';
            }

            return field.getAttribute('data-msg-required') || 'This field is required.';
        },
    },

    /**
     * Make tel inputs accepts just numbers and init international tel input
     */
    telInputs: {
        selector: '[type="tel"]',
        init: function () {
            var base = this,
                container = $(base.selector);

            // Prevent conflicting if there are more than one form
            container.each(function () {
                var currentForm = $(this);

                // Make input accepts just numbers
                currentForm.on('keyup', function (e) {
                    //this.value = this.value.replace(/(?!-)[^+0-9.]+/g,'');
                    this.value = this.value.replace(/[^+0-9 \.-]+$/, '');
                    /*if ( /[^+0-9 \.-]+$/.test(e.key) ) {
						e.preventDefault();
					}*/
                });

                var iti = window.intlTelInput(currentForm[0], {
                    initialCountry: 'auto',
                    nationalMode: false,
                    autoPlaceholder: 'aggressive',
                    //separateDialCode: true,
                    geoIpLookup: function (callback) {
                        $.get(
                            'https://ipinfo.io',
                            function (resp) {
                                var countryCode =
                                    resp && resp.country ? resp.country : onyx_js_localized.user_country_code;

                                callback(countryCode);

                                // Set user selected country
                                if (resp.country !== undefined) {
                                    currentForm.parents('form').find('[name="user_country"]').val(resp.country);
                                }
                            },
                            'jsonp',
                        )
                            .always()
                            .fail(function () {
                                callback(onyx_js_localized.user_country_code);
                            });
                    },
                    utilsScript: '/wp-content/themes/onyx-praxis/assets/js/vendors/utils.js',
                });

                // Set user selected country and dialcode on country change
                currentForm[0].addEventListener('countrychange', function () {
                    var selectedCountryData = iti.getSelectedCountryData();

                    // Set user selected country and dialcode
                    if (selectedCountryData.name !== undefined) {
                        currentForm.parents('form').find('[name="user_country"]').val(selectedCountryData.name);
                    }

                    if (selectedCountryData.dialCode !== undefined) {
                        currentForm.parents('form').find('[name="user_dialcode"]').val(selectedCountryData.dialCode);
                    }
                });
            });
        },
    },

    /**
     *	Number field
     **/
    numberField: {
        selector: 'input.just-numbers',
        init: function () {
            var base = this,
                container = $(base.selector);

            // Make input accepts just numbers
            container.on('keyup', function () {
                this.value = this.value.replace(/([^0-9.,]+$)/, '');
            });
        },
    },

    /**
     *	Input float label
     **/
    floatLabel: {
        selector: '.float-label',
        init: function () {
            var base = this,
                container = $(base.selector);

            // Start Bootstrap validation
            container.each(function () {
                $(this).each(function () {
                    var $this = $(this),
                        floatField = $this.find('input,select,textarea'),
                        floatFieldLabel = $this.find('label');

                    // Set active class if it has a value
                    if (
                        floatField.val() &&
                        floatField.val() !== '' &&
                        floatField.val() !== ' ' &&
                        floatField.val() !== undefined
                    ) {
                        $this.addClass('active');
                    }

                    /*floatField.next('label').on('click', function(e) {
						$this.addClass('active');
					});*/

                    // Check if the field is not readonly
                    if (!floatField.is('[readonly]')) {
                        floatField.on('focus', function () {
                            $this.addClass('active');
                        });

                        floatField.on('blur', function () {
                            if (floatField.val() === '') {
                                setTimeout(function () {
                                    $this.removeClass('active');
                                }, 50);
                            }
                        });
                    }
                });
            });
        },
    },

    /**
     * Skrollr parallax elements :)
     **/
    skrollrInit: {
        selector: '.parallax-element',
        _resizeTimer: null,
        init: function () {
            // Respect user preference for reduced motion
            if (Onyx._prefersReducedMotion.matches) {
                return;
            }

            var base = this,
                s = skrollr.init(),
                skrollrConfig = {
                    forceHeight: !1,
                    easing: 'easeInOutElastic',
                    mobileCheck: function () {
                        return !1;
                    },
                };

            s.destroy();

            $(window).on('resize', function () {
                clearTimeout(base._resizeTimer);
                base._resizeTimer = setTimeout(function () {
                    var a = $(window).width();

                    if (a < 1036) s.destroy();
                    else skrollr.init(skrollrConfig);
                }, 250);
            });

            var c = $(window).width();

            if (c >= 1036) {
                skrollr.init(skrollrConfig);
            }
        },
    },

    /**
     *	Extend jQuery to add a function to detect if element is in view
     **/
    isVisible: ($.fn.isVisible = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop() - $(window).outerHeight() / 2; // Detect it before coming to viewport
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }),

    /**
     * Fade-in images as they enter the viewport.
     *
     * Uses IntersectionObserver to detect visibility, then waits for the
     * native `load` event before adding `.img--lazy-loaded` (which triggers
     * the CSS opacity transition). No src swapping — browsers handle lazy
     * loading natively via `loading="lazy"`.
     **/
    lazyLoadImages: {
        selector: '.img--fade-in',
        init: function () {
            var images = document.querySelectorAll('.img--fade-in');
            var deferred = [];

            var reveal = function (img) {
                if (img.complete && img.naturalWidth > 0) {
                    img.classList.add('img--lazy-loaded');
                } else {
                    img.addEventListener('load', function () {
                        img.classList.add('img--lazy-loaded');
                    });
                    img.addEventListener('error', function () {
                        img.classList.add('img--lazy-loaded');
                    });
                }
            };

            // Split: already-loaded images reveal immediately,
            // pending images use IntersectionObserver for the fade-in delay.
            images.forEach(function (img) {
                if (img.complete && img.naturalWidth > 0) {
                    reveal(img);
                } else {
                    deferred.push(img);
                }
            });

            if (deferred.length > 0 && 'IntersectionObserver' in window) {
                var observer = new IntersectionObserver(
                    function (entries) {
                        entries.forEach(function (entry) {
                            if (entry.isIntersecting) {
                                reveal(entry.target);
                                observer.unobserve(entry.target);
                            }
                        });
                    },
                    { rootMargin: '50px' },
                );

                deferred.forEach(function (img) {
                    observer.observe(img);
                });
            } else {
                deferred.forEach(reveal);
            }
        },
    },

    /**
     * Viewport entering animation
     **/
    onyxEnteringAnimation: {
        selector: '.animation-trigger',
        init: function () {
            var base = this,
                container = $(base.selector),
                delayIterator = 0;

            // Respect user preference for reduced motion
            if (Onyx._prefersReducedMotion.matches) {
                $(base.selector).addClass('element-reveal');
                return;
            }

            /*
             *	Start first loop on containers
             */
            container.each(function () {
                var currentContainer = $(this);

                currentContainer.children().each(function () {
                    var self = $(this),
                        elementOffset = currentContainer.attr('data-offset')
                            ? currentContainer.attr('data-offset') + '%'
                            : '100%',
                        animationClass = self.attr('data-animation') ? self.attr('data-animation') : 'step-up',
                        animationDelay = self.attr('data-animation-delay')
                            ? self.attr('data-animation-delay')
                            : delayIterator + 's';

                    self.css({
                        '-webkit-transition-delay': animationDelay,
                        '-moz-transition-delay': animationDelay,
                        'transition-delay': animationDelay,
                    });

                    self.addClass(animationClass);

                    if (currentContainer.isVisible()) {
                        currentContainer.addClass('element-reveal');
                        //.toggleClass(osAnimationClass);
                    }

                    // Start the scroll event
                    $(window).on('resize scroll', function () {
                        container.each(function () {
                            if (currentContainer.isVisible()) {
                                currentContainer.addClass('element-reveal');
                            }
                        });
                    });

                    delayIterator += 0.2;
                });

                delayIterator = 0;
            });
        },
    },

    /**
     * Initialize Onyx popup modal
     * Add new popup function
     **/
    popupFunctions: {
        selector: '.popup',
        init: function () {
            var base = this,
                //container = $('a[data-target-popup]'),
                container = $(base.selector);

            // Check if there is a cookie to not show popup
            // if ( $.cookie( 'onyx-dont-show-subscribe-popup' ) ) {
            //	return;
            //}

            container.each(function () {
                if ($(this).attr('data-popup') === 'show-on-open') {
                    Onyx.log('Subscribe popup is here!');

                    var modalHolder = $(this);

                    // Show our popup after 5 seconds
                    setTimeout(function () {
                        Onyx.popupFunctions.open(modalHolder);
                    }, 5000);
                } else {
                }
            });

            $('a[data-target-popup]').each(function () {
                var modalHolder = $('[data-popup=\"' + $(this).attr('data-target-popup') + '\"]');

                // Defining our data ID and Ajax Url
                var detailedDataType = $(this).attr('data-type');

                $(this).on('click', function (e) {
                    Onyx.log('A popup should open now!');
                    Onyx.popupFunctions.open(modalHolder);
                });

                modalHolder.find('.popup__content').on('click', function (e) {
                    e.stopPropagation();
                });

                // Init closing popup modal
                modalHolder.on('click', function (e) {
                    Onyx.popupFunctions.close(e, modalHolder);
                });

                modalHolder.find('.popup__close, #onyx-popup > .close').on('click', function (e) {
                    e.preventDefault();
                    Onyx.popupFunctions.close(e, modalHolder);
                });

                // on esc too
                $(window).on('keyup', function (e) {
                    if (e.keyCode === 27) {
                        Onyx.popupFunctions.close(e, modalHolder);
                    }
                });
            });
        },

        // Store the element that had focus before popup opened
        _previousFocus: null,

        open: function (modalHolder) {
            // Store focus to restore on close
            Onyx.popupFunctions._previousFocus = document.activeElement;

            // Prevent scroll on body
            $('html').addClass('overflow-hidden');

            modalHolder.fadeIn(300).css('display', 'block');
            modalHolder.addClass('opened');

            // Cache focusable selector for reuse
            var focusableSelector =
                'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

            // Focus the first focusable element inside the popup
            var focusable = modalHolder.find(focusableSelector).filter(':visible');

            if (focusable.length) {
                focusable.first().trigger('focus');
            }

            // Set up focus trap
            modalHolder.off('keydown.focustrap').on('keydown.focustrap', function (e) {
                if (e.which !== 9) return; // Only trap Tab key
                var focusableEls = modalHolder.find(focusableSelector).filter(':visible');
                var firstEl = focusableEls.first();
                var lastEl = focusableEls.last();

                if (e.shiftKey) {
                    if ($(document.activeElement).is(firstEl)) {
                        e.preventDefault();
                        lastEl.trigger('focus');
                    }
                } else {
                    if ($(document.activeElement).is(lastEl)) {
                        e.preventDefault();
                        firstEl.trigger('focus');
                    }
                }
            });
        },

        close: function (event, modalHolder) {
            if (modalHolder.hasClass('opened')) {
                // Prevent scroll on body
                $('html').removeClass('overflow-hidden');

                // Close popup
                modalHolder.fadeOut(300);
                modalHolder.removeClass('opened');

                // Remove focus trap
                modalHolder.off('keydown.focustrap');

                // Restore focus to the previously focused element
                if (Onyx.popupFunctions._previousFocus) {
                    $(Onyx.popupFunctions._previousFocus).trigger('focus');
                    Onyx.popupFunctions._previousFocus = null;
                }

                // Prepare our event when closing popup
                $(document).trigger({
                    type: 'closingPopup',
                    message: 'Our popup has been closed!',
                    time: new Date(),
                });

                // Reset inner form
                if (modalHolder.find('form').length > 0 && modalHolder.attr('data-reset-on-close')) {
                    Onyx.resetForm(modalHolder.find('form'));
                }
            }
        },
    },

    /**
     * Video block
     **/
    videoBlock: {
        selector: '.video-block',
        init: function () {
            var base = this,
                container = $(base.selector),
                videoId = container.attr('data-video'),
                iframe;

            container.find('.video-block__play').each(function () {
                $(this).on('click keydown', function (e) {
                    if (e.type === 'keydown' && e.which !== 13 && e.which !== 32) return;
                    e.preventDefault();
                    $(this).closest('.video-block').addClass('video-block--start');

                    if (container.find('iframe.video-block__iframe').length === 0) {
                        iframe = $('<iframe class="video-block__iframe" title="Video player"></iframe>').appendTo(
                            container.find('.video-block__inner'),
                        );

                        iframe
                            .attr('frameborder', '0')
                            .attr('allowfullscreen', '1')
                            .attr('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture')
                            .attr(
                                'src',
                                'https://www.youtube.com/embed/' +
                                    videoId +
                                    '?showinfo=0&controls=0&rel=0&modestbranding=1&enablejsapi=1&autoplay=1',
                            );
                    }
                });
            });

            container.find('.video-block__stop').each(function () {
                $(this).on('click keydown', function (e) {
                    if (e.type === 'keydown' && e.which !== 13 && e.which !== 32) return;
                    if (e.type === 'keydown') e.preventDefault();
                    $(this).closest('.video-block').removeClass('video-block--start');
                    iframe.remove();
                });
            });
        },
    },

    /**
     * FAQ accordion
     **/
    faqBlock: {
        selector: '.faq-block',
        init: function () {
            $('.faq-block__trigger').on('click', function () {
                var $item = $(this).closest('.faq-block__item');
                var $answer = $item.find('.faq-block__answer');
                var isActive = $item.hasClass('faq-block__item--active');

                $item.toggleClass('faq-block__item--active');
                $(this).attr('aria-expanded', !isActive);

                if (isActive) {
                    $answer.attr('hidden', '');
                } else {
                    $answer.removeAttr('hidden');
                }
            });
        },
    },

    /**
     * Tabbed panels
     **/
    tabsBlock: {
        selector: '.tabs-block',
        init: function () {
            $('.tabs-block').each(function () {
                var $block = $(this);
                var $tabs = $block.find('.tabs-block__tab');
                var $panels = $block.find('.tabs-block__panel');

                $tabs.on('click', function () {
                    var $tab = $(this);
                    var panelId = $tab.attr('aria-controls');

                    // Deactivate all
                    $tabs.removeClass('tabs-block__tab--active').attr('aria-selected', 'false').attr('tabindex', '-1');
                    $panels.attr('hidden', '');

                    // Activate clicked
                    $tab.addClass('tabs-block__tab--active').attr('aria-selected', 'true').attr('tabindex', '0');
                    $('#' + panelId).removeAttr('hidden');
                });

                // Keyboard arrow navigation (RTL-aware)
                $tabs.on('keydown', function (e) {
                    var index = $tabs.index(this);
                    var nextIndex;
                    var isRTL = getComputedStyle(document.body).direction === 'rtl';

                    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                        var isNext = (e.key === 'ArrowRight' && !isRTL) || (e.key === 'ArrowLeft' && isRTL);
                        if (isNext) {
                            nextIndex = (index + 1) % $tabs.length;
                        } else {
                            nextIndex = (index - 1 + $tabs.length) % $tabs.length;
                        }

                        $tabs.eq(nextIndex).trigger('click').trigger('focus');
                        e.preventDefault();
                    }

                    if (e.key === 'Home') {
                        $tabs.eq(0).trigger('click').trigger('focus');
                        e.preventDefault();
                    }

                    if (e.key === 'End') {
                        $tabs
                            .eq($tabs.length - 1)
                            .trigger('click')
                            .trigger('focus');
                        e.preventDefault();
                    }
                });
            });
        },
    },

    /**
     * Add title attribute to Google Maps iframes for accessibility
     **/
    googleMapA11y: {
        selector: '[role="application"][aria-label]',
        init: function () {
            var base = this,
                container = $(base.selector);

            container.each(function () {
                var $mapContainer = $(this);
                var mapTitle =
                    $mapContainer.attr('data-map-title') || $mapContainer.attr('aria-label') || 'Google Maps';

                var observer = new MutationObserver(function (mutations, obs) {
                    var $untitled = $mapContainer.find('iframe:not([title])');
                    if ($untitled.length) {
                        $untitled.attr('title', mapTitle);
                        obs.disconnect(); // Clean up after iframe is titled
                    }
                });

                observer.observe(this, { childList: true, subtree: true });

                // Also check for any iframes already present
                var $existing = $mapContainer.find('iframe:not([title])');
                if ($existing.length) {
                    $existing.attr('title', mapTitle);
                    observer.disconnect();
                }
            });
        },
    },

    /**
     * Load more posts (generic – works with any post type)
     **/
    loadMorePosts: {
        selector: 'button.main-btn--show-more',
        init: function () {
            var self = this;

            $(document).on('click', self.selector, function () {
                var $btn = $(this);
                var $container = $btn.closest('.row').prev('.row');

                if (!$container.length || !$container.data('post-type')) {
                    return;
                }

                self._loadMore($btn, $container);
            });
        },

        _loadMore: function ($btn, $container) {
            var postType = $container.data('post-type'),
                postsLimit = parseInt($container.data('posts-limit'), 10) || 9,
                currentCount = $container.children('article').length,
                category = $container.data('posts-category') || 'all',
                order = $container.data('posts-order') || 'DESC',
                orderby = $container.data('posts-orderby') || 'date',
                excludeId = parseInt($container.data('exclude-id'), 10) || 0,
                lang = $container.data('lang') || '',
                originalLabel = $btn.text(),
                $status = $btn.siblings('.main-btn--show-more__status');

            // Prevent double-clicks
            if ($btn.prop('disabled')) {
                return;
            }

            $btn.prop('disabled', true).attr('aria-busy', 'true').text(onyx_js_localized.loading);

            $.ajax({
                url: onyx_js_localized.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'onyx_load_more_posts',
                    nonce: onyx_js_localized.nonce,
                    post_type: postType,
                    offset: currentCount,
                    posts_limit: postsLimit,
                    posts_category: category,
                    posts_order: order,
                    posts_orderby: orderby,
                    exclude_id: excludeId,
                    lang: lang,
                },
                success: function (res) {
                    if (!res.success || !res.data.html || res.data.returned === 0) {
                        // No more posts — hide the button
                        $btn.closest('.row').remove();
                        return;
                    }

                    // Parse and append new posts
                    var $newItems = $(res.data.html);

                    $container.append($newItems);

                    // Announce to screen readers
                    $status.text(res.data.returned + (res.data.returned === 1 ? ' item loaded' : ' items loaded'));

                    // Update the found count in case it changed
                    $container.data('found', res.data.found);

                    var newCount = $container.children('article').length;

                    if (newCount >= res.data.found) {
                        // All posts loaded — remove the button row
                        $btn.closest('.row').remove();
                        $container.removeClass('mb-xs');
                    } else {
                        $btn.prop('disabled', false).attr('aria-busy', 'false').text(originalLabel);
                    }
                },
                error: function () {
                    // Re-enable on error so user can retry
                    $btn.prop('disabled', false).attr('aria-busy', 'false').text(originalLabel);
                    $status.text(onyx_js_localized.loading_error || 'Failed to load. Please try again.');
                },
            });
        },
    },

    /**
     * Reset form fields
     **/
    loader: {
        show: function (container) {
            if (container !== 'undefined') {
                container.append(
                    '<div class="loading-container"><div class="loading-spinner"><div class="circle_01"></div><div class="circle_02"></div><div class="circle_03"></div><div class="circle_04"></div><div class="circle_05"></div><div class="circle_06"></div><div class="circle_07"></div><div class="circle_08"></div></div></div>',
                );
                container.addClass('ajax-loader');
            }
        },
        remove: function (container) {
            if (container !== 'undefined') {
                container.removeClass('ajax-loader');
                container.children('.loading-container').remove();
            }
        },
    },

    /**
     * Reset form fields
     **/
    resetForm: function (currentForm) {
        currentForm
            .find(
                'input[type="text"], input[type="tel"], input[type="email"], input[type="password"], input[type="file"], select, textarea',
            )
            .val('');
        currentForm.find('input[type="radio"], input[type="checkbox"]').removeAttr('checked').removeAttr('selected');
        currentForm
            .find(
                'input[type="text"], input[type="password"], input, input[type="file"], select, textarea, input[type="radio"], input[type="checkbox"]',
            )
            .parent()
            .find('.form-control-feedback')
            .hide();
        currentForm.find('.has-feedback').removeClass('has-feedback');
        currentForm.find('.has-success').removeClass('has-success');
        currentForm.find('.has-error').removeClass('has-error');
        currentForm.find('.help-block').remove();
        currentForm.find('[aria-invalid]').removeAttr('aria-invalid').removeAttr('aria-describedby');

        // Reset floating label
        var floatContainer = currentForm.find('.float-label');

        floatContainer.each(function () {
            var floatField = jQuery(this).find('input,select,textarea');

            // Set active class if it has a value
            if (
                floatField.val() &&
                floatField.val() !== '' &&
                floatField.val() !== ' ' &&
                floatField.val() !== undefined
            ) {
                jQuery(this).addClass('active');
            } else {
                jQuery(this).removeClass('active');
            }
        });
    },
};

!(function ($) {
    'use strict';

    $(document).ready(function () {
        Onyx.init(jQuery);
    });
})(jQuery);

/**
 * Init recaptcha, callback in functions.php
 **/
if (typeof grecaptcha !== 'undefined') {
    console.log('Recaptcha is here');

    var reCaptchaIDs = [];
    var onyx_logged_in = '';
    var onyx_show_captcha = false;

    var onyxReCaptchaLoad = function () {
        jQuery('.recaptcha').each(function (index, el) {
            var container = jQuery(this).parents('form');
            var tempID = grecaptcha.render(el, {
                sitekey: site_key,
                theme: 'light',
                //'type'	: 'image',
                badge: 'inline',
                size: 'invisible',
                //'callback' : globalFormsAjax
                callback: function (token) {
                    globalFormsAjax(token, container);
                },
                //'size'	: (jQuery(window).outerWidth() < 480) ? 'compact' : 'normal'
            });

            reCaptchaIDs.push(tempID);
        });
    };

    //Reset reCaptcha
    var onyxReCaptchaReset = function () {
        if (typeof reCaptchaIDs != 'undefined') {
            var arrayLength = reCaptchaIDs.length;

            for (var i = 0; i < arrayLength; i++) {
                grecaptcha.reset(reCaptchaIDs[i]);
            }
        }
    };
}

var globalFormsAjax = function (token, container) {
    var currentForm = container;

    $.ajax({
        type: 'post', //currentForm.attr('method')
        url: onyx_js_localized.ajaxurl,
        data: currentForm.serialize(),
        dataType: 'JSON',

        beforeSend: function () {
            Onyx.loader.show(currentForm); // Show loader
        },
        success: function (res) {
            Onyx.loader.remove(currentForm); // Remove loader

            // Ensure message container is a live region for screen readers
            currentForm.find('.styled-form__msg').attr({
                role: 'status',
                'aria-live': 'polite',
                'aria-atomic': 'true',
            });

            if (res.success === true) {
                // Show message - Messages are in the PHP functions
                currentForm.find('.styled-form__msg').children('.alert').addClass('alert-success').html(res.msg); // Give it a success!
                currentForm
                    .find('.styled-form__msg')
                    .stop(0, 0)
                    .slideDown(500, function () {
                        jQuery(this).css('height', 'auto').addClass('active');
                    });
            } else {
                // Show message - Messages are in the PHP functions
                currentForm.find('.styled-form__msg').children('.alert').addClass('alert-danger').html(res.msg); // Give it a failure!
                currentForm
                    .find('.styled-form__msg')
                    .stop(0, 0)
                    .slideDown(500, function () {
                        jQuery(this).css('height', 'auto').addClass('active');
                    });
            }

            // Reset recaptcha challenge
            if (typeof grecaptcha !== 'undefined') {
                onyxReCaptchaReset();
            }

            // Reset the form fields on success
            if (res.success === true) {
                Onyx.resetForm(currentForm);
            }
        },
        error: function (xhr, status, error) {
            try {
                var err = JSON.parse(xhr.responseText);

                console.log(err.msg);
            } catch (e) {
                console.log('AJAX error:', status, error);
            }
        },
    });
};
